import { Box } from '@/src/packages/components';
import { useProductPrice } from '@/src/packages/hooks/use-product-price';
import { IFetchProductPriceListByCountry } from '@bitmap/contracts';

const ProductPriceTaxDisclaimer = () => {
  // return (
  //   {prices?.salesTaxRate && prices.salesTaxRate > 0 ? (
  //     <Box
  //       fontFamily="sans"
  //       color="weak"
  //       className="mt-auto ml-1 leading-none"
  //       textSize="sm"
  //     >
  //       includes sales tax
  //     </Box>
  //   ) : (
  //     <></>
  //   )}
  // )
};

export const ProductPrice = ({
  priceList,
}: {
  priceList: IFetchProductPriceListByCountry;
}) => {
  const prices = useProductPrice(priceList);

  return (
    <Box display="flex">
      <Box fontFamily="sans" textSize="lg" className="leading-none">
        {prices?.priceGrossFormatted}
      </Box>
    </Box>
  );
};
